import { useCallback } from 'react';
import { api } from 'src/constants/apiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';
interface S3UploadReceiptAttachResponse {
  processedFiles: string[];
  unProcessed: { fileName: string; errorMessage: string }[];
}
export interface S3UploadReceiptAttachRequest {
  fileName: string;
  signedUrl: string;
  fileNameWithAttachId: string;
  attachId: number;
}
const useS3ReceiptAttach = (companyId: number, id?: number) => {
  const call = useCallback(
    async (params: S3UploadReceiptAttachRequest[] = []) => {
      try {
        const response = await axiosInstance.post<S3UploadReceiptAttachResponse>(
          api.uploadScanManagerReceiptRecordFn(companyId, id),
          params
        );
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    [companyId, id]
  );
  const { execute, isLoading } = useAsync(call, false);
  return {
    S3ReceiptAttach: execute,
    isS3ReceiptFileAttaching: isLoading,
  };
};
export default useS3ReceiptAttach;
